import { readOnly, map, gt, mapBy, min, max } from '@ember/object/computed';
import { isPresent } from '@ember/utils';
import EmberObject, { computed } from '@ember/object';
import InventoryEventWrapper from '@square/dashboard-items-data/models/wrappers/inventory-event-wrapper';
import InventoryQuantity from '@square/dashboard-items-data/models/squareup/inventory/v3/inventory-quantity';
import Money from '@square/dashboard-money/models/money';
import DecimalStockCount from '@square/dashboard-items-data/models/decimal-stock-count';

// eslint-disable-next-line ember/no-classic-classes
export default EmberObject.extend({
  aggregatedInventoryEvent: null,
  // AggregatedInventoryEvent proto fields
  inventoryEvents: readOnly('aggregatedInventoryEvent.inventoryEvents'),
  // Computed helpers
  inventoryEventWrappers: map('inventoryEvents', function (inventoryEvent) {
    return InventoryEventWrapper.create({
      inventoryEvent
    });
  }),
  isAggregate: gt('inventoryEventWrappers.length', 1),
  firstEvent: readOnly('inventoryEventWrappers.firstObject'),
  connectOauthClientName: readOnly('firstEvent.connectOauthClientName'),
  eventType: readOnly('firstEvent.eventType'),
  itemName: readOnly('firstEvent.itemName'),
  variationName: readOnly('firstEvent.variationName'),
  variationSku: readOnly('firstEvent.variationSku'),
  variationUpc: readOnly('firstEvent.variationUpc'),
  isWontFulfilTransferOrder: readOnly('firstEvent.isWontFulfilTransferOrder'),
  isReceivedTransferOrder: readOnly('firstEvent.isReceivedTransferOrder'),
  quantity: computed('inventoryEventWrappers.@each.quantity', function () {
    let quantity = InventoryQuantity.create();
    this.inventoryEventWrappers.forEach(function (event) {
      quantity = quantity.add(event.get('quantity'));
    });
    return quantity;
  }),
  quantityCount: readOnly('quantity.count'),
  quantityDecimal: computed('inventoryEventWrappers.@each.quantityDecimal', function () {
    return this.inventoryEventWrappers.reduce((sum, current) => {
      return sum.add(current.quantityDecimal);
    }, DecimalStockCount.zero());
  }),
  fromUnitToken: readOnly('firstEvent.fromUnitToken'),
  toUnitToken: readOnly('firstEvent.toUnitToken'),
  occurredAt: mapBy('inventoryEventWrappers', 'occurredAt'),
  minOccurredAt: min('occurredAt'),
  maxOccurredAt: max('occurredAt'),
  employeeToken: mapBy('inventoryEventWrappers', 'employeeToken'),
  totalCost: computed('firstEvent.totalCost.currencyCode', 'inventoryEventWrappers.@each.totalCost', function () {
    let totalCost = null;
    this.inventoryEventWrappers.forEach(function (event) {
      if (isPresent(event.totalCost)) {
        if (totalCost === null) {
          totalCost = Money.zero(event.totalCost.currencyCode);
        }
        totalCost = totalCost.add(event.totalCost);
      }
    });
    return totalCost;
  }),
  displayName: readOnly('firstEvent.displayName'),
  measurementUnit: readOnly('firstEvent.measurementUnit')
});